import { render, staticRenderFns } from "./TrainingCenterListing.vue?vue&type=template&id=378495e4&scoped=true&"
import script from "./TrainingCenterListing.vue?vue&type=script&lang=js&"
export * from "./TrainingCenterListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378495e4",
  null
  
)

export default component.exports